import * as actionTypes from '../types/correctionReadyProducts';

const initialState = {
  readyProducts: [],
  error: false,
  loading: false,
  okRequest: false,
  okRequestModal: false,
  loadingModal: false,
  loadingMounting: false,
  okrequestMounting: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_READY_PRODUCTS:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.GET_READY_PRODUCTS_SUCCESS:
      return {
        ...state,
        readyProducts: payload,
        loading: false
      };
    case actionTypes.GET_READY_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.DELETE_READY_PRODUCTS:
      return {
        ...state,
        loadingModal: true,
        okRequestModal: false
      };
    case actionTypes.DELETE_READY_PRODUCTS_SUCCESS:
      return {
        ...state,
        loadingModal: false,
        okRequestModal: true
      };
    case actionTypes.DELETE_READY_PRODUCTS_FAIL:
      return {
        ...state,
        loadingModal: false,
        okRequestModal: true
      };
    case actionTypes.DELETE_READY_PRODUCTS_MULTIPLE:
      return {
        ...state,
        loadingModal: true,
        okRequestModal: false
      };
    case actionTypes.DELETE_READY_PRODUCTS_MULTIPLE_SUCCESS:
      return {
        ...state,
        loadingModal: false,
        okRequestModal: true
      };
    case actionTypes.DELETE_READY_PRODUCTS_MULTIPLE_FAIL:
      return {
        ...state,
        loadingModal: false,
        okRequestModal: true
      };
    case actionTypes.SEND_FOR_MOUNTING:
      return {
        ...state,
        loadingMounting: true,
        okrequestMounting: false
      };
    case actionTypes.SEND_FOR_MOUNTING_SUCCESS:
      return {
        ...state,
        loadingMounting: false,
        okrequestMounting: true
      };
    case actionTypes.SEND_FOR_MOUNTING_FAIL:
      return {
        ...state,
        loadingMounting: false,
        okrequestMounting: true
      };
    default:
      return state;
  }
};

export default reducer;
